import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, PesquisaMunicipios } from './types';

export const INITIAL_STATE: PesquisaMunicipios = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): PesquisaMunicipios {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PESQUISA_MUNICIPIOS_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.PESQUISA_MUNICIPIOS_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.PESQUISA_MUNICIPIOS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.PESQUISA_MUNICIPIOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
